import React, { useContext } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

import { UserContext } from '@/context/userContext';
import { isUserInGroup } from '@/auth/EricksonAuthenticator';
import MLInactiveFlagsManager from '@/components/MLInactiveFlagsManager';

const MLInactiveFlagsPage: React.FC = () => {
  const userContext = useContext(UserContext);

  return userContext.user ? (
    isUserInGroup(userContext.user, 'Admin') ? (
      <Box ml={3} mr={3} mt={2}>
        <Typography variant="h2" mb={2} fontWeight={400}>
          ML Inactive Flags Management
        </Typography>
        <MLInactiveFlagsManager />
      </Box>
    ) : (
      <div>Unauthorized</div>
    )
  ) : (
    <CircularProgress />
  );
};

export default MLInactiveFlagsPage;
